var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-error"},[_c('div',{staticClass:"header"},[_vm._v("Data loading error")]),_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.errorMsg))]),_c('div',{staticClass:"details"},_vm._l((_vm.details),function(msg){return _c('div',[_vm._v(_vm._s(msg))])}),0),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }